"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _chunkPSZ3GTKOjs = require('./chunk-PSZ3GTKO.js');


var _chunkOSY2MDAPjs = require('./chunk-OSY2MDAP.js');

// src/js/colors/colors.ts
var colors = {
  light: {
    ..._chunkOSY2MDAPjs.lightTheme.colors
  },
  dark: {
    ..._chunkPSZ3GTKOjs.darkTheme.colors
  }
};



exports.colors = colors;
//# sourceMappingURL=chunk-HBRFHMQM.js.map